module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2000-04-06/4-b6efc19607123c202c0764484485fa3f.jpg";